import {JSONMapped, jsonProperty} from "json-mapper-reflect";

export class UnattachedPurchase extends JSONMapped() {
	@jsonProperty()
	description: string;

	@jsonProperty()
	partNumber: string;

	@jsonProperty()
	eligibleDevices?: Array<{aircraftTailNumber: string, id: number, name: string}>;

	@jsonProperty()
	eligibleAircraft?: Array<{id: string}>;

	constructor(data?: Partial<UnattachedPurchase>) {
		super();
		Object.assign(this, data);
		if (this.eligibleAircraft == null) {
			this.eligibleAircraft = [];
		}
		if (this.eligibleDevices == null) {
			this.eligibleDevices = [];
		}
	}
}
